import React, { Component } from 'react'
import Radium from 'radium';
import Row from '../ShortTermProjects/Workplace/Invoice/spreadsheets/table/row'
import Cell from '../ShortTermProjects/Workplace/Invoice/spreadsheets/table/cellNew'
import Header from '../ShortTermProjects/Workplace/Invoice/spreadsheets/table/header'
import { semanticColors } from '../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Crew extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '40%',
                '10%',
                '40%',
                '10%',
            ],
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.crewKey === nextProps.crewKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Funktion'}
                    style={{ width: this.state.width[0] }}
                />
                <Header
                    content={'Start'}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Slut'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
            </Row>
        )
    }
    round15up = (x) => {
        return Math.round(x / 15) * 15;
    }
    filterOnlyDigits = (s) => {
        return s.replace(/[^0-9.,:]/g, "")
    }
    rounxs = (x) => {
        x = x.replace('.', '')
        var end_minutes = x.slice(-2);
        var end_hour = x.slice(0, -2);
        var minutes = this.round15up(end_minutes)
        // eslint-disable-next-line
        if (minutes == 0) minutes = '00'
        // eslint-disable-next-line
        else if (minutes >= 60) {
            minutes = '00'
            end_hour = parseInt(end_hour, 10) + 1
            if (end_hour < 10) {
                end_hour = '0' + end_hour
            }
            end_hour = end_hour + ':'
        }
        if (parseInt(end_hour,10) >= 24) { end_hour = '00:' }
        return end_hour + minutes
    }

    updateMarkers = (index, value, row) => {
        let nvalue = value
        let inputAsArray = value.split(':')
        if (inputAsArray.length === 2 && (inputAsArray[0].length === 2 && inputAsArray[1].length === 2)) {
            nvalue = this.rounxs(this.filterOnlyDigits(value))
        }
        row.markers[index] = nvalue
        this.props.update(row.function, row)
    }

    updateFunction = (key, value, obj) => {
        obj[key] = value
        this.props.update(obj.function, obj)
    }
    updateChildFunction = (key, value, obj, row, index) => {
        obj[key] = value
        row.details[index] = obj
        this.props.update(row.function, row)
    }

    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    renderContent = (r, index) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        return (
            <Row
                key={r.function}
            >
                <Cell
                    onChange={(value) => this.updateFunction('functionDisplay', value, r)}
                    content={r.functionDisplay}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        fontWeight: 600,
                        backgroundColor: background
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    inputClassName="fa"
                    content={r.function !== 'pause' && !this.props.open ? (r.unfolded ? "\uf0d8" : "\uf0d7") : ''}
                    readOnly
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        ':hover': {
                            cursor: 'pointer'
                        }
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    inputClassName="fa"
                    content={r.function !== 'pause' && !this.props.open ? (r.unfolded ? "\uf0d8" : "\uf0d7") : ''}
                    readOnly
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        ':hover': {
                            cursor: 'pointer'
                        }
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    onChange={(value) => this.updateFunction('price', -Math.abs(value.replace('-', '')), r)}
                    readOnly={r.function !== 'pause'}
                    content={r.price.toString().replace('.00', '').replace('.', ',')}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        fontWeight: 600,
                    }}
                />
            </Row>
        )
    }
    renderChildContent = (r, count, index, row) => {
        let marker1 = '00:00';
        let marker2 = '23:59';

        if(index !== 3) {
            marker1 = row.markers[index]
            marker2 = row.markers[(index + 1 > 2 ? 0 : index + 1)]
        }

        let background = count % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        return (
            <Row
                key={r.descriptionKey}
            >
                <Cell
                    onChange={(value) => this.updateChildFunction('description', value, r, row, index)}
                    content={r.description}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                <Cell
                    onChange={(value) => {
                        if( index !== 3) {
                            this.updateMarkers(index, value, row)
                        }
                        }
                        }
                    content={marker1}
                    onFocusOut={() => {
                    }}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        borderBottom: marker1.length === 5 ? null : '1px solid red',
                        ':focus': { borderBottom: marker1.length === 5 ? '1px solid white' : '1px solid red' },
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => {
                        if( index !== 3) {
                            this.updateMarkers((index + 1 > 2 ? 0 : index + 1), value, row)
                        }
                        }}
                    content={marker2}
                    onFocusOut={() => {
                    }}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        borderBottom: marker2.length === 5 ? null : '1px solid red',
                        ':focus': { borderBottom: marker2.length === 5 ? '1px solid white' : '1px solid red' },
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => {
                        let cal = value.replace(',', '.')
                        this.updateChildFunction('price', cal, r, row, index)
                    }}
                    content={(r.price).toString().replace('.', ',')}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
            </Row>
        )
    }
    render() {
        let rows = []
        let count = -1
        for (var key in this.props.rows) {
            if (this.props.rows.hasOwnProperty(key)) {
                count += 1
                const row = this.props.rows[key]
                rows.push(this.renderContent(row, count))
                if (row.unfolded || this.props.open) {
                    row.details.map((d, index) => {
                        rows.push(this.renderChildContent(d, count, index, row))
                    })
                }
            }
        }
        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
            </div>
        )
    }
}

// const styles = {
//     flexify: {
//         display: 'flex',
//         flexDirection: 'row',
//     },
//     column: {
//         flexGrow: 0,
//         flexShrink: 0,
//         verticalAlign: 'top',
//     }
// }

Crew.propTypes = propTypes

Crew.defaultProps = defaultProps

export default Radium(Crew)


// WEBPACK FOOTER //
// ./src/App/CustomPricelist/crew.js